class ClientPagePresenter {
  constructor(view, signInUseCase, signOutUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.signOutUseCase = signOutUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  async submit() {
    try {
      const user = {
        ...this.change,
      };
      this.view.showProgress();
      const signedInUser = await this.signInUseCase.execute(user);

      this.view.navigateTo("/admin/employees");
      this.view.reload();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default ClientPagePresenter;
